import { action } from 'mobx'
import ListStore from '../../../shared-lib/stores/ListStore'
import BookingModel, { $BookingModel } from './BookingModel'
import listeners from '../../communication/Listeners'

export default class BookingStore extends ListStore<$BookingModel> {
  fetchMethodName = 'bookings'
  ModelClass = BookingModel
  defaultFetchVariables = {
    filter: {
      status: { $ne: 'DRAFT' },
    },
  }

  // Listen on bookings and update bookings on changes
  @action.bound async listenOnBookings_api() {
    const { userStore: { data: { _id } }, communication, dropdownMessageHandler, i18n: { s } } = this.rootStore
    const { mergeData } = this

    return communication.client.subscribe<Subscription>({
      query: listeners.bookingUpdated,
      variables: { userId: _id },
    }).subscribe({
      next(res) {
        const data = res.data?.bookingUpdated?.booking
        data && mergeData([data])
      },
      error() {
        dropdownMessageHandler.showDropdownMessage({
          title: s('There was an issue fetching the latest booking data. Please refresh.'),
          type: 'error',
          closeInterval: 1000,
        })
      },
    })
  }

  fetchAddressParkingInformation = async (addressId: string) => {
    const { communication: { requester } } = this.rootStore

    try {
      this.setLoading(true)
      const ret = await requester.getParkingInformation({ addressId }, {})
      this.setLoading(false)
      if (!ret.getParkingInformation) return null
      const parkingInformation = { ...ret.getParkingInformation } as any
      delete parkingInformation.__typename
      return parkingInformation
    } catch (e) {
      this.setLoading(false)
      return null
    }
  }

  addOrUpdateParkingInformation = async (data: ParkingInformationInput) => {
    const { communication: { requester } } = this.rootStore

    try {
      this.setLoading(true)
      const ret = await requester.addorUpdateParkingInformation({ data }, {})
      this.setLoading(false)
      return ret.addorUpdateParkingInformation
    } catch (e) {
      this.setLoading(false)
      return null
    }
  }

  // Clear all data (used for the logout)
  clearData = () => {
    this.items = []
  }

  getBookingsForHomepage_api = async () => {
    const { communication: { requester }, externalBookingStore } = this.rootStore

    try {
      this.setLoading(true)
      const ret = await requester.getBookingsForHomepage({}, {})
      this.setLoading(false)
      if (!ret.getBookingsForHomepage) return

      const { bookings, externalBookings, ...numbers } = ret.getBookingsForHomepage

      this.mergeData(bookings)
      externalBookingStore.mergeData(externalBookings)

      return numbers
    } catch (e) {
      this.setLoading(false)
      return
    }
  }
}

export type $BookingStore = BookingStore
